<template>
  <span class="version">
    <!-- The running version links to its own entry in the changelog. `?version=` rather than a
         `#anchor`: anchors are built from the server's release slug, which the build has no way
         of knowing — What's New resolves the number to the right entry on arrival. -->
    <router-link
      class="version-number black--text"
      :to="{ name: 'releases', query: { version } }"
      :title="`See what changed in v${version}`">
      <i class="fad fa-box-check mr-1 ml-2"></i>v{{ version }}
    </router-link>
    <span>
      <v-chip
        class="elevation-2 ml-2 py-0 font-weight-bold d-flex"
        x-small
        hide-details
        color="pink darken-1 white--text"
        v-if="isTestEnv"
        style="line-height: 0">
        <v-icon size="13" class="mr-1" style="line-height: 0" left>mdi-test-tube</v-icon>TEST
      </v-chip>
      <v-chip
        class="elevation-2 ml-2 py-0 px-2 font-weight-bold d-flex"
        x-small
        hide-details
        color="primary"
        v-else-if="isDevEnv"
        style="line-height: 0">
        <v-icon size="13" class="mr-1" style="line-height: 0" left>mdi-xml</v-icon>
        DEV
      </v-chip>
      <v-chip
        class="elevation-2 ml-2 py-0 px-2 font-weight-bold d-flex"
        x-small
        hide-details
        color="deep-purple darken-1 white--text"
        v-else-if="isDemoEnv"
        style="line-height: 0">
        <v-icon size="13" class="mr-1" style="line-height: 0" left>mdi-presentation</v-icon>
        DEMO
      </v-chip>
    </span>
  </span>
</template>
<script>
  import { version } from '../../../../package.json';
  export default {
    name: 'version-component',
    data() {
      return {
        version,
      };
    },
    computed: {
      isTestEnv() {
        return process.env.VUE_APP_TYPE === 'staging';
      },
      isDevEnv() {
        return process.env.VUE_APP_TYPE === 'development';
      },
      isDemoEnv() {
        return process.env.VUE_APP_TYPE === 'demo';
      },
    },
  };
</script>
<style lang="scss">
  .version {
    display: flex;
    // width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    line-height: 0;
    margin-top: 0.35rem;
    margin-bottom: 0.25rem;

    .version-number {
      opacity: 0.54;
      color: var(--v-bg_force_Grey-base);
    }

    // The version reads as chrome, not as a link, until it is pointed at — an underlined link in
    // the corner of every page would pull more attention than a build number deserves.
    a.version-number {
      text-decoration: none;
      transition: opacity 0.2s ease;

      &:hover,
      &:focus-visible {
        opacity: 1;
        text-decoration: underline;
      }
    }
  }
</style>
